import React from 'react';
import { SimpleSelect } from 'react-selectize';

function SelectOneWidget(props) {
  const options = props.formContext.data[props.options.optionsField].map(opt => ({
    value: opt.name,
    label: opt.name,
  }));
  const valueItem = options.find(option => option.value === props.value);

  return (
    <SimpleSelect
      disabled={props.disabled || props.readonly}
      options={options}
      value={valueItem || null}
      onValueChange={v => props.onChange(v && v.value)}
    />
  );
}

export default SelectOneWidget;



// WEBPACK FOOTER //
// ./src/byob-cms/src/AppLib/formLib/SelectOneWidget.js